import { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { getProduitsByCategorieId, getCategoriesWithImages } from '../services/categorieTitreService';
import { PanierContext } from '../context/PanierContext';
import { asset } from '../services/api';
import '../styles/CategorieProduits.css';
import { FaMapMarkerAlt, FaTimes } from 'react-icons/fa';

function CategorieProduits() {
  const { id } = useParams();
  const { ajouterAuPanier } = useContext(PanierContext);

  // 🔵 Récupérer la langue depuis le localStorage
  const [lang, setLang] = useState(localStorage.getItem("lang") || "fr");

  const [produits, setProduits] = useState([]);
  const [categorieNom, setCategorieNom] = useState('');
  const [quantities, setQuantities] = useState({});

  // 🔵 Message d'ajout au panier
  const [showMessage, setShowMessage] = useState(false);
  const [productName, setProductName] = useState('');

  const [currentPage, setCurrentPage] = useState(1);

  // 🔵 États modale
  const [selectedProduit, setSelectedProduit] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const productsPerPage = 9;
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = produits.slice(indexOfFirstProduct, indexOfLastProduct);

  // 🔵 Mise à jour langue à chaque changement dans NavBar
  useEffect(() => {
    const handleLangUpdate = () => {
      setLang(localStorage.getItem("lang") || "fr");
    };
    window.addEventListener("langChanged", handleLangUpdate);

    return () => window.removeEventListener("langChanged", handleLangUpdate);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const produitsData = await getProduitsByCategorieId(id);
        setProduits(produitsData);
        setCurrentPage(1);

        const categories = await getCategoriesWithImages();
        const selected = categories.find(c => c.id === parseInt(id));
        if (selected) setCategorieNom(selected.categorie);
      } catch (error) {
        console.error("Erreur chargement produits :", error);
      }
    };
    fetchData();
  }, [id]);

  const handleQuantityChange = (index, value) => {
    const newQuantities = { ...quantities };
    newQuantities[index] = parseFloat(value) || 1;
    setQuantities(newQuantities);
  };

  const handleAddToCart = (product, index) => {
    let quantity = parseFloat(quantities[index]) || 1;
    quantity = Math.max(0.1, quantity);

    ajouterAuPanier({
      id: `${product.id}-${product.vendeur_id}`,
      nom: product.title || product.titre,
      prix: parseInt(product.price),
      quantite: quantity,
      unite: 'kg',
    });

    setProductName(product.title || product.titre);
    setShowMessage(true);
    setTimeout(() => setShowMessage(false), 3000);
  };

  // 🔵 Modale
  const openModal = (produit) => {
    setSelectedProduit(produit);
    setShowModal(true);
  };

  const closeModal = () => {
    setSelectedProduit(null);
    setShowModal(false);
  };

  // 📌 Traductions FR / MG
  const T = {
    discover: lang === "fr" ? "Découvrez tous les produits disponibles dans cette catégorie"
                            : "Jereo eto daholo ny vokatra ao anatin’ity sokajy ity",

    quantity: lang === "fr" ? "Quantité (kg)" : "Habetsahana (kg)",

    addToCart: lang === "fr" ? "Ajouter au panier" : "Ampidiro ao anaty harona",

    noProduct: lang === "fr" ? "Aucun produit dans cette catégorie."
                             : "Tsy misy vokatra ao amin'ity sokajy ity.",

    added: lang === "fr" ? "ajouté au panier" : "nampiana tao anaty harona",

    description: lang === "fr" ? "Description" : "Famaritana",

    detailedDescription: lang === "fr" ? "Description détaillée" : "Famaritana amin’ny antsipiriany",

    lieu: lang === "fr" ? "Lieu" : "Toerana",

    price: lang === "fr" ? "Prix" : "Vidiny",

    category: lang === "fr" ? "Catégorie" : "Sokajy",
  };

  return (
    <div className="categorie-produits-container main-content">
      <section className="hero">
        <div className="hero-text">
          <h1>{categorieNom ? categorieNom : (lang === "fr" ? "Catégorie" : "Sokajy")}</h1>
          <p>{T.discover}</p>
        </div>
      </section>

      {/* 🔵 Message ajouté au panier */}
      {showMessage && (
        <div className="cart-message">
          ✅ {productName} {T.added} !
        </div>
      )}

      <div className="categorie-product-list">
        {currentProducts.length > 0 ? (
          currentProducts.map((prod, index) => {
            const realIndex = indexOfFirstProduct + index;

            return (
              <div key={prod.id} className="categorie-product-card">
                <img
                  src={asset(prod.img)}
                  alt={prod.title || prod.titre}
                  style={{ cursor: 'pointer' }}
                  onClick={() => openModal(prod)}
                />

                <div className="categorie-product-info">
                  <h3>{prod.titre}</h3>
                  <p>{prod.description}</p>

                  <p className="product-lieu">
                    <FaMapMarkerAlt style={{ color: '#2e5d3d', marginRight: 5 }} />
                    {prod.lieu}
                  </p>

                  <div className="categorie-price-container">
                    <span>{prod.price} Ar / kg</span>
                  </div>

                  <div className="categorie-quantity-container">
                    <label>{T.quantity} :</label>

                    <input
                      type="number"
                      min="1"
                      step="1"
                      value={quantities[realIndex] || 1}
                      onChange={(e) => handleQuantityChange(realIndex, e.target.value)}
                    />
                  </div>

                  <div className="categorie-button-container">
                    <button onClick={() => handleAddToCart(prod, realIndex)}>
                      {T.addToCart}
                    </button>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <p style={{ fontStyle: 'italic' }}>{T.noProduct}</p>
        )}
      </div>

      {/* 🔵 Pagination */}
      <div className="categorie-pagination">
        {Array.from({ length: Math.ceil(produits.length / productsPerPage) }, (_, i) => (
          <button
            key={i}
            className={currentPage === i + 1 ? 'active' : ''}
            onClick={() => setCurrentPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}
      </div>

      {/* 🔵 Modale produit */}
      {showModal && selectedProduit && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <FaTimes className="modal-close-icon" onClick={closeModal} />

            <h2>{selectedProduit.titre}</h2>

            <img
              src={asset(selectedProduit.img)}
              alt={selectedProduit.titre}
              style={{ maxWidth: '100%', borderRadius: 8 }}
            />

            <p><strong>{T.description} :</strong> {selectedProduit.description}</p>
            <p><strong>{T.detailedDescription} :</strong> {selectedProduit.description_detaillee}</p>
            <p><strong>{T.category} :</strong> {categorieNom}</p>
            <p><strong>{T.lieu} :</strong> {selectedProduit.lieu}</p>
            <p><strong>{T.price} :</strong> {selectedProduit.price} Ar / {selectedProduit.unite || "kg"}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default CategorieProduits;
